import React from 'react'
import { useGetStudentsReportQuery } from 'features'
import { ResourceContainer } from 'components'
import { ViewStudentsReport, StudentReportSchoolCycleSelect } from 'pages/reports/students-report'

export default function ViewStudentsReportContainer(_props) {
  let customParams = { cycle: `${new Date().getFullYear()}` }

  return (
    <ResourceContainer
      resource={useGetStudentsReportQuery}
      resourceName="studentsReport"
      customParams={customParams}
    >
      <StudentReportSchoolCycleSelect />
      <ViewStudentsReport />
    </ResourceContainer>
  )
}
